import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { SidebarState } from '@/store/types';

export const useSidebarStore = create<SidebarState>()(
  persist(
    set => ({
      selectedGroupKey: null,
      panelOpen: true,
      mobileOpen: false,
      setSelectedGroupKey: key => set({ selectedGroupKey: key }),
      setPanelOpen: open => set({ panelOpen: open }),
      togglePanel: () => set(s => ({ panelOpen: !s.panelOpen })),
      setMobileOpen: open => set({ mobileOpen: open }),
    }),
    {
      name: 'sidebar-store',
      partialize: s => ({
        selectedGroupKey: s.selectedGroupKey,
        panelOpen: s.panelOpen,
      }),
    },
  ),
);
